import type { SVGProps } from "react";
const SvgLinkedin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    fill="none"
    {...props}
  >
    <path
      fill="#0A66C2"
      d="M24.08 0H1.92A1.92 1.92 0 0 0 0 1.92v22.16A1.92 1.92 0 0 0 1.92 26h22.16A1.92 1.92 0 0 0 26 24.08V1.92A1.92 1.92 0 0 0 24.08 0M7.75 22.149H3.84V9.732h3.91zM5.791 8.01A2.244 2.244 0 1 1 8.05 5.77 2.21 2.21 0 0 1 5.792 8.01M22.158 22.16H18.25v-6.784c0-2-.85-2.618-1.949-2.618-1.159 0-2.296.874-2.296 2.669v6.733h-3.91V9.74h3.76v1.72h.05c.378-.763 1.7-2.068 3.716-2.068 2.181 0 4.538 1.294 4.538 5.086z"
    />
  </svg>
);
export default SvgLinkedin;